// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../stores/mobx-compat";
import { withRouter } from '../../router-compat';

import Modal from '../ui/Modal';
import Button from '../ui/Button';
import {
  ChevronLeftIcon, ChevronRightIcon, CheckIcon, MailIcon, InfoIcon,
} from '../ui/icons';

class Tour extends Component {
  nextHandler = () => {
    const { tour } = this.props.store;
    if (tour.currentTour.nextUrl) this.props.history.push(tour.currentTour.nextUrl);
    if (tour.tourIndex === tour.tourArray.length - 1) tour.endTour();
    else tour.nextStep();
  }

  backHandler = () => {
    const { tour } = this.props.store;
    if (tour.tourIndex) {
      tour.backStep();
      this.props.history.goBack();
    }
  }

  render() {
    const { tour } = this.props.store;
    if (!tour.displayTour || !tour.currentTour) return null;
    const isLast = tour.tourIndex === tour.tourArray.length - 1;
    const { currentTour } = tour;

    return (
      <Modal
        open
        onClose={tour.endTour}
        size="md"
        title={currentTour.header}
        icon={InfoIcon}
        closeOnScrim={false}
        actions={(
          <>
            <Button icon={MailIcon} onClick={() => window.open('mailto:info@automatedremarketing.com', '_blank')}>
              Email us
            </Button>
            {tour.tourIndex !== 0 && (
              <Button icon={ChevronLeftIcon} onClick={this.backHandler}>Back</Button>
            )}
            <Button
              variant="primary"
              iconRight={isLast ? CheckIcon : ChevronRightIcon}
              onClick={this.nextHandler}
            >
              {isLast ? 'End tour' : 'Next'}
            </Button>
          </>
        )}
      >
        <p className="m-0 text-[13px] text-mov-ink-soft" style={{ lineHeight: 1.55 }}>
          {currentTour.message}
        </p>
        {currentTour.image && (
          <img
            src={currentTour.image}
            alt=""
            style={{ marginTop: 14, width: '100%', borderRadius: 10, border: '1px solid var(--mov-line)' }}
          />
        )}
      </Modal>
    );
  }
}

export default withRouter(inject('store')(observer(Tour)));
